import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { UiServicesLogger, UiServicesUtils, UiServiceWebSession } from '@drct-web-apps/ui-services';
import { DRCTEvent, DRCTEventView } from '@drct-web-apps/ui-types';
import { UiWebEventCardComponent } from '@drct-web-apps/ui-web-event-card';
import { UiWebPageTitleComponent } from '@drct-web-apps/ui-web-page-title';
import { ReplaySubject, takeUntil } from 'rxjs';



@Component({
  selector: 'ui-web-events',
  templateUrl: './ui-web-events.component.html',
  imports: [ UiWebPageTitleComponent, UiWebEventCardComponent, CommonModule ]
})
export class UiWebEventsComponent implements OnInit, OnDestroy {
  @Input() showPageTitle = true;
  @Input() showAllEvents = true;

  private readonly destroyed$: ReplaySubject<boolean> = new ReplaySubject(1);
  
  public events: DRCTEvent[] = [];

  constructor(private readonly http: HttpClient, private readonly utils: UiServicesUtils,
              private readonly logger: UiServicesLogger, private readonly session: UiServiceWebSession) { }

  ngOnInit(): void {
    if(this.session.initComplete) {
      this.loadAllEvents();
    }
    else {
      this.session.sessionReady
                  .pipe(takeUntil(this.destroyed$))
                  .subscribe((ready: boolean) => {
                    if(ready) {
                      this.loadAllEvents();
                    }
                  });  
    }
  }

  ngOnDestroy() {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  

  private loadAllEvents(): void {
    this.http.post(this.utils.builApiUrlWithEnv("drct_events_view.php"), { opr: "limited", uuid: (this.session.webConfig?.uuid ?? '') })
             .pipe(takeUntil(this.destroyed$))
             .subscribe({
                next:(response: DRCTEventView) => {
                  if(response.success && response.tot_rows &&  response.tot_rows > 0) {
                    this.events = response.events ?? [];
                    this.events = (this.showAllEvents)? this.events: this.events.slice(0, 3);
                  }
                },
                error: (error) => {
                  this.events = [];
                  this.logger.error("Error loading events. Error: " + error);
                }
              });
  }

}